// eslint-disable-next-line no-unused-vars
import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line no-unused-vars
import { FxBreadcrumbs, FxTabContainer } from 'axp-fx-common';
import { useSelector } from 'react-redux';
import { dlsGray06, Heading } from '@americanexpress/dls-react'; // eslint-disable-line no-unused-vars
// eslint-disable-next-line no-unused-vars
import ContactInformationExternalDirectory from './ContactInformationExternalDirectory';
// eslint-disable-next-line no-unused-vars
import ContactInformationAxpDirectory from './ContactInformationAxpDirectory';
import { contactInformationBreadcrumbs } from '../../../constants/breadcrumbs';

const ContactInformationDirectory = ({ setStepNo, setSelectedContact }) => {
  const loginData = useSelector((state) => state.getIn([
      'modules',
      'axp-secure-file-express-root',
      'userData',
      'login',
    ])
  );

  const { companyName } = loginData?.userDetail || {};

  return (
    <>
      <FxBreadcrumbs breadcrumbItems={contactInformationBreadcrumbs} />

      <Heading level={2} theme={dlsGray06} headingStyle="heading5">
        Contact Information Directory
      </Heading>
      <div className="margin-2-t">
        <FxTabContainer
          tabs={[
            {
              id: 'externalContacts',
              name: companyName ? `${companyName} Contacts` : 'Contacts',
              content: (
                <ContactInformationExternalDirectory
                  setStepNo={setStepNo}
                  setSelectedContact={setSelectedContact}
                />
              ),
            },
            {
              id: 'axpContacts',
              name: 'AMEX Contacts',
              content: <ContactInformationAxpDirectory />,
            },
          ]}
          defaultSelectedTab="externalContacts"
        />
      </div>
    </>
  );
};

ContactInformationDirectory.propTypes = {
  setStepNo: PropTypes.func.isRequired,
  setSelectedContact: PropTypes.func.isRequired,
};

export default ContactInformationDirectory;
